<template>
  <div class="card-wrapper info">
    <!--头部-->
    <div class="head box">
      <div>组织信息</div>
      <!--展示状态时按钮-->
      <div v-if="!isEdit">
        <Button type="primary" @click="isEdit = true">编辑</Button>
      </div>
      <!--编辑状态时按钮-->
      <div v-else>
        <Button @click="isEdit = false" style="margin-right: 20px">取消</Button>
        <Button type="primary" @click="saveInfo">保存</Button>
      </div>
    </div>
    <!--内容-->

    <div class="content">
      <!--组织头像-->
      <div class="box v-center">
        <div class="title-">组织标志</div>
        <!--展示状态-->
        <div style="position: relative;">
          <!--有头像时-->
          <img v-if="info.pic" :src="info.pic.path" class="img" />
          <!--没有头像时-->
          <div v-else class="img no-img box">
            <div class="iconfont icon-zuzhibiaozhimoren"></div>
          </div>
          <!--编辑状态 -->
          <div class="edit-img img" v-if="isEdit" @click="addHeadpic">
            <input
              type="file"
              id="uploads"
              class="upload-btn"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="uploadImg"
              hidden
            />
            <div class="iconfont icon-bianji1"></div>
          </div>
        </div>
      </div>

      <!--组织名称-->
      <div class="box v-center">
        <div class="title-">组织名称</div>
        <!--展示状态-->
        <div v-if="!isEdit">{{info.name}}</div>
        <!--编辑状态-->
        <Input v-else v-model="info.name" class="input" :maxlength="32" />
      </div>

      <!--组织简介-->
      <div class="box">
        <div class="title-">组织简介</div>
        <!--展示状态-->
        <div v-if="!isEdit">{{info.remark}}</div>
        <!--编辑状态-->
        <div v-else class="box" style="position: relative;">
          <Input type="textarea" :maxlength="140" v-model="info.remark" class="input" :rows="4" />
          <div class="num">{{info.remark.length}}/140</div>
        </div>
      </div>

      <div class="box">
        <div class="title-">联系人</div>
        <!--展示状态-->
        <div v-if="!isEdit">{{info.userName}}</div>
        <!--编辑状态-->
        <Input v-else v-model="info.userName" class="input" :maxlength="32" />
      </div>

      <div class="box">
        <div class="title-">联系电话</div>
        <!--展示状态-->
        <div v-if="!isEdit">{{info.userPhoneNO}}</div>
        <!--编辑状态-->
        <Input v-else v-model="info.userPhoneNO" class="input" :maxlength="32" />
      </div>
      <div class="box">
        <div class="title-">地址</div>
        <!--展示状态-->
        <div v-if="!isEdit">{{info.address}}</div>
        <!--编辑状态-->
        <template v-else>
          <div v-if="info.address" class="address slh" :title="info.address" @click="showmap()">{{ info.address }}</div>
          <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
          <map-modal v-if="showMap" @confirm="getAddress" @cancel="showmap" :zuobiao="zuobiao"></map-modal>
        </template>
      </div>
    </div>

    <!--上传图片-->
    <upload-img
      class="upload-img"
      :imgArr="imgArr"
      :imgWidth="120"
      :imgHeight="75"
      @saveImg="saveImg"
      @delPic="delPic"
      :isClick="isClick"
      :isClickE="isClickE"
      :imgNumber="imgNumber"
      :fixedNumber="fixedNum"
    ></upload-img>
  </div>
</template>

<script>
import uploadImg from "@/components/uploadImg";
import mapModal from "@/components/mapModal";
export default {
  name: "orgInfo",
  props: {
    oldInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {
    uploadImg,
    mapModal,
  },
  watch: {
    //传入的info 复制一份
    oldInfo: {
      handler: function (newV, oldV) {
        this.info = JSON.parse(JSON.stringify(newV));
        console.log(this.info)
        let coordinate = this.info.coordinate?JSON.parse(this.info.coordinate):""
        this.zuobiao.label = this.info.address;
        this.zuobiao.value = coordinate.x + ',' + coordinate.y;
      },
      deep: true, //深度监听设置为 true
      immediate: true,
    },
    //编辑状态变回不可编辑时   info信息复原
    isEdit() {
      if (!this.isEdit) {
        this.info = JSON.parse(JSON.stringify(this.oldInfo));
        console.log(this.info);
      }
    },
  },
  data() {
    return {
      isEdit: false, //是否是编辑状态，初始未编辑
      info: {
        name: "",
        remark: "",
        pic: {},
        // userName: "",
        // userPhoneNO: "",
        // address:"",
        // coordinate:""
      },
      imgArr: [],
      imgNumber: 5,
      fixedNum: [8, 5],
      isClick: 0, // 上传图片的事件触发标志
      isClickE: null, // 上传图片事件的触发对象 event
      clickUpload: "",
      showMap: false,
      zuobiao: {
        value: "",
        label: "",
      },
    };
  },
  methods: {
    showmap() {
      this.showMap = !this.showMap;
    },
    getAddress(val) {
      this.zuobiao = val;
      console.log("-----------------", this.zuobiao);
      this.info.address = val.label;
      this.coordinate = val.value;
      this.showmap();
    },
    // 添加图片 触发上传图片按钮
    addHeadpic() {
      this.clickUpload = "head";
      this.fixedNum = [1, 1];
      let oInput = document.getElementById("uploads");
      oInput.click();
    },
    // 选择文件 触发
    uploadImg(selectFileEvent) {
      this.isClick++;
      this.isClickE = selectFileEvent;
    },
    saveImg(data) {
      console.log(data);
      if (this.clickUpload == "head") {
        this.info.pic = data;
        this.fixedNum = [8, 5];
        this.clickUpload = "";
      } else {
        this.imgArr.push(data);
      }
    },
    delPic() {},
    saveInfo() {
      var url = this.urlobj.changeOrg;
      var coordinate = "";
      if (this.zuobiao.value) {
        var zuobiao = this.zuobiao.value.split(",");
        coordinate = '{"x":"' + zuobiao[0] + '","y":"' + zuobiao[1] + '"}';
        console.log(coordinate);
      }
      this.$post(url, {
        id: this.$parent.id,
        communityId: parseInt(this.$parent.communityId),
        orgName: this.info.name,
        remark: this.info.remark,
        userName: this.info.userName,
        userPhoneNO: this.info.userPhoneNO,
        headPicUrl: this.info.pic.path,
        comeType: this.$parent.comeType,
        coordinate: this.info.address ? coordinate : "",
        address: this.info.address ? this.info.address : ""
      }).then((res) => {
        this.$parent.info = this.info;
        this.isEdit = false;
      });
    },
  },
};
</script>

<style scoped lang="less">
.card-wrapper /deep/ .ivu-btn {
  padding: 1px 15px 2px;
}
.card-wrapper /deep/ .ivu-input {
  font-size: 14px;
}
.card-wrapper {
  width: 98%;
  margin: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.info {
  .head {
    padding: 0 20px;
    border-bottom: 1px solid #ddd;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    font-size: 19px;
    color: #4b4b4b;
  }
}
.content {
  padding: 20px;
  font-size: 15px;
  line-height: 1;
  .box {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .title- {
    min-width: 85px;
    text-align: left;
  }
  .img {
    height: 70px;
    width: 70px;
    border-radius: 50%;
  }
  .no-img {
    background: #dcdcdc;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
    .iconfont {
      font-size: 47px;
      color: #c1c1c1;
    }
  }
  .edit-img {
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    .iconfont {
      color: #fff;
      font-size: 30px;
      padding-top: 3px;
      padding-left: 3px;
    }
  }
  .input {
    width: 660px;
  }
  .num {
    color: #999;
    align-self: flex-end;
    margin-left: 10px;
    position: absolute;
    bottom: 6px;
    right: 6px;
  }
  .address {
    width: 65%;
    height: 32px;
    line-height: 24px;
    padding: 4px 7px;
    font-size: 12px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;
  }

  .address_nodata {
    color: #bbb;
  }

  .address:hover {
    border: 1px solid #ff7b44;
  }

  .address:active {
    border: 1px solid #ff7b44;
  }
}
.v-center {
  align-items: center;
}
</style>
